import { ReduxSagaRequest } from "@hlibs/index";
import * as Requests from "./requests";

class Account extends ReduxSagaRequest {
  static create = (name, funcAsync = null, funcResult = null) =>
    new Account(name, funcAsync, funcResult);

  get user() {
    return super.getState("user");
  }

  get isTokenChecked() {
    return super.getState("checked") || false;
  }

  // callback : (data, response) => {}
  signup(params, callback = null) {
    super.request({ type: "SignUp", params, callback });
  }
  pwChange(params, callback = null) {
    super.request({ type: "PwChange", params, callback });
  }

  // callback : (data, response) => {}
  login(id, pw, callback = null) {
    super.request({ type: "Login", params: { id, pw }, callback });
  }

  // callback : (data, response) => {}
  tokenCheck(callback = null) {
    super.request({ type: "TokenCheck", callback });
  }

  // callback : (data, response) => {}
  logout(callback = null) {
    super.request({ type: "Logout", callback });
  }
  // callback : (data, response) => {}
  reset(params, callback = null) {
    super.request({ type: "Reset", params, callback });
  }

  // callback : (data, response) => {}
  update(params, callback = null) {
    super.request({ type: "Update", params, callback });
  }

  // callback : (data, response) => {}
  withdraw(callback = null) {
    super.request({ type: "Withdraw", callback });
  }

  resetTokenCheck() {
    super.set(false, "checked");
  }

  cleanLoginResponse() {
    super.set(null, "Login");
  }

  cleanSignUpResponse() {
    super.set(null, "SignUp");
  }
}

const reduxModule = Account.create("Account", async (payload) => {
  switch (payload.type) {
    case "SignUp":
      return await Requests.SignUp(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "PwChange":
      return await Requests.PwChange(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Login":
      return await Requests.Login(
        payload.params,
        payload.callback,
        reduxModule
      );

    case "TokenCheck":
      return await Requests.TokenCheck(payload.callback, reduxModule);
    case "Logout":
      return await Requests.Logout(payload.callback, reduxModule);
    case "Reset":
      return await Requests.Reset(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Update":
      return await Requests.Update(
        payload.params,
        payload.callback,
        reduxModule
      );
    case "Withdraw":
      return await Requests.Withdraw(payload.callback, reduxModule);
    default:
      return null;
  }
});

export default reduxModule;
